/** Teks saklar "Tunjuk otomatis saat diminta" (#63) di "Gaya & aturan Jenna". */
export interface AssistantAutoPointText {
	title: string;
	description: string;
	enabled: string;
}

const id: AssistantAutoPointText = {
	title: "Tunjuk otomatis",
	description:
		"Saat pengguna meminta menampilkan atau menunjukkan sesuatu (mis. “tampilkan data keuangan”), atau menjawab “iya” atas tawaran Jenna, layar langsung menunjuk bagian yang dimaksud tanpa perlu mengulang. Matikan bila ingin Jenna selalu menjawab dengan teks dulu.",
	enabled: "Tunjuk otomatis saat diminta",
};

const en: AssistantAutoPointText = {
	title: "Automatic pointing",
	description:
		"When a user asks to show or display something (e.g. “show the finance data”), or answers “yes” to an offer to show it, the screen points at the right part right away without repeating. Turn off to make the assistant answer in text first.",
	enabled: "Point automatically when asked",
};

export const assistantAutoPointTexts = { id, en } as const;
